import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import TenantsBlock from '../../components/ui/TenantsBlock/TenantsBlock';
import { getEntitiesWithAddress } from '../../utils/getEntitiesWithAddress';
import useHousingStockState from '../../hooks/useHousingStockState';
import styles from './TenantsPage.module.scss';

const TenantsPage = () => {
  const [tenants, setTenants] = useState([]);

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const { housingStockQueryKey, housingStockState } = useHousingStockState();

  const housingStock = useMemo(
    () => housingStockState?.data || [],
    [housingStockState]
  );

  useEffect(() => {
    if (housingStock.length) {
      const tenants = getEntitiesWithAddress(housingStock, 'clients');

      setTenants(tenants);
    }
  }, [housingStock]);

  return (
    <Spin spinning={housingStockState?.isFetching}>
      <article className={styles.container}>
        <TenantsBlock
          companyName={currentCompany?.name}
          tenants={tenants}
          queryKeys={[housingStockQueryKey]}
        />
      </article>
    </Spin>
  );
};

export default TenantsPage;
